import React from "react";
import "./deleteModal.css";
import { CheckCircle, Close } from "@material-ui/icons";
import { Link, useHistory } from "react-router-dom";

function DeleteModal({ closeModal, children }) {
  let history = useHistory();

  return (
    <div className="modalBg">
      <div className="modalContainer">
        <div className="titleCloseBtn">
          <div></div>
          <button className="doneIcon">
            <CheckCircle className="checkMarkIcon" />
          </button>
          <button
            className="closeModalBtn"
            onClick={() => {
              history.goBack();
              closeModal(false);
            }}
          >
            <Close />
          </button>
        </div>
        <div className="modalTxt">{children}</div>
      </div>
    </div>
  );
}

export default DeleteModal;
